import styled from '@emotion/styled';
import { breakpoints, colors, fontFamilies } from '../baseStyle/Variables';
import { css } from '@emotion/core';

const FormNavButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const FormSubHeader = styled.p`
  text-align: left;
  font-size: 22px;
  text-align: center;

  @media (max-width: ${breakpoints.md}) {
    font-size: 18px;
  }
`;

const FormInputHeader = styled.p`
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 33px;
  letter-spacing: -0.015em;
  margin-bottom: 0;
`;

const FormInputLabel = styled.label`
  font-family: ${fontFamilies.interRegular};
  margin: 0.5rem 0 0.3rem 0;
  font-size: 10px;
  color: ${colors.darkGray};
  font-weight: 600;
`;

const FormInputErrorText = styled.span`
  top: 5px;
  font-size: 0.75rem;
  line-height: 1.5rem;
  padding-left: 0.5rem;
  text-overflow: ellipsis;
  color: ${colors.errorRed};
`;

const FormFinePrint = styled.p`
  font-family: ${fontFamilies.interRegular};
  margin: 1rem 0;
  font-size: 0.88rem;
  color: ${colors.black};
  a {
    font-size: 0.88rem;
    color: ${colors.koalafiBlue};
    text-decoration: none;
    font-weight: 600;
  }
  b {
    font-family: ${fontFamilies.gilroySemiBold};
  }
  text-align: center;
`;

// Checkbox is used for radio buttons too, don't want the styles to conflict
const Checkbox = styled.input<{ type: string }>`
  flex-shrink: 0;
  appearance: none;
  width: ${(props) => (props.type === 'checkbox' ? '1.25rem' : '1rem')};
  height: ${(props) => (props.type === 'checkbox' ? '1.25rem' : '1rem')};
  box-sizing: ${(props) => (props.type === 'checkbox' ? 'border-box' : 'content-box')};
  border: 1px solid ${colors.gray};
  border-radius: ${(props) => (props.type === 'checkbox' ? '2px' : '50%')};
  position: relative;

  &:hover {
    background: linear-gradient(0deg, ${colors.lightBlue}, ${colors.lightBlue});
  }

  &:focus {
    border: 2px solid ${colors.koalafiBlue};
  }
  &:checked {
    background-position: center;
    ${(props) =>
      props.type === 'checkbox'
        ? css`
            background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 2C0 0.895431 0.895431 0 2 0H18C19.1046 0 20 0.895431 20 2V18C20 19.1046 19.1046 20 18 20H2C0.895431 20 0 19.1046 0 18V2Z' fill='%233D6EDF'/%3E%3Cpath d='M7.86332 12.5833L5.08332 9.80333L4.13666 10.7433L7.86332 14.47L15.8633 6.47L14.9233 5.53L7.86332 12.5833Z' fill='white'/%3E%3C/svg%3E%0A");
            background-repeat: no-repeat;
            background-size: cover;
            background-color: ${colors.koalafiBlue};
          `
        : css`
            background: radial-gradient(${colors.koalafiBlue} 50%, ${colors.white} 55%);
          `}
  }
`;

export { FormNavButtonWrapper, FormFinePrint, FormInputErrorText, FormInputHeader, FormSubHeader, FormInputLabel, Checkbox };
